import get from 'lodash.get';
import getIsB2C from './is-b2c';

const getPublicRoadmapURL = (rootState) => {
  if (getIsB2C(rootState)) {
    return get(rootState, 'config.common.yola-public-roadmap.url');
  }

  return get(rootState, 'config.common.yola-public-roadmap.wl_url');
};

export default getPublicRoadmapURL;
